import React from 'react';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-gradient-to-b from-blue-900 to-blue-800 text-white pt-12 pb-20 px-4 overflow-hidden" data-id="element-52">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-53">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-white blur-3xl" data-id="element-54"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 rounded-full bg-orange-500 blur-3xl" data-id="element-55"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-56">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-57">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left" data-id="element-58">
            <div className="inline-block px-4 py-1 bg-orange-500/20 border border-orange-400/50 rounded-full text-orange-300 text-sm font-bold mb-6 tracking-wide uppercase" data-id="element-59">
              Para docentes de secundaria
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6" data-id="element-60">
              Teoría de las <br data-id="element-61" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-200" data-id="element-62">
                Organizaciones 360
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-blue-100 mb-8 leading-relaxed font-light" data-id="element-63">
              La herramienta definitiva para enseñar organizaciones{' '}
              <span className="font-bold text-white" data-id="element-64">sin improvisar</span>,
              durante todo el ciclo lectivo.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-65">
              <Button variant="primary" size="xl" onClick={scrollToPurchase} className="shadow-orange-900/20" data-id="element-66">
                Quiero mis clases listas →
              </Button>
            </div>

            <p className="mt-4 text-sm text-blue-200 opacity-80" data-id="element-67">
              🔒 Compra 100% segura • Acceso inmediato
            </p>
          </div>

          {/* Image */}
          <div className="flex-1 w-full max-w-md md:max-w-full" data-id="element-68">
            <div className="relative group cursor-pointer transform transition-transform hover:scale-105 duration-300" onClick={scrollToPurchase} data-id="element-69">
              <div className="absolute -inset-1 bg-gradient-to-r from-orange-500 to-blue-500 rounded-2xl blur opacity-30 group-hover:opacity-60 transition duration-200" data-id="element-70"></div>
              <img src="https://cdn.magicpatterns.com/uploads/9nrHgrHNZX2cKgxXVvQXXf/COVER_TDLO360.png" alt="Teoría de las Organizaciones 360 Portada" className="relative rounded-xl shadow-2xl w-full border-2 border-white/10" data-id="element-71" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}